/**
 * Dashboard 常量和配置
 */

import React from 'react';
import {
    BarChartOutlined,
    TeamOutlined,
    TagsOutlined,
    ThunderboltOutlined,
    RocketOutlined,
    TrophyOutlined,
    SafetyCertificateOutlined,
} from '@ant-design/icons';
import { Tag } from 'antd';
import type { DashboardStats } from '../../services/dashboardService';

// 类别信息配置
export const getCategoryInfo = (category: string) => {
    switch (category) {
        case 'policy':
            return { color: '#f59e0b', text: '政策规则', bgColor: 'rgba(245, 158, 11, 0.1)' };
        case 'official':
            return { color: '#10b981', text: '官方资讯', bgColor: 'rgba(16, 185, 129, 0.1)' };
        case 'service':
            return { color: '#6366f1', text: '服务动态', bgColor: 'rgba(99, 102, 241, 0.1)' };
        case 'announcement':
            return { color: '#ec4899', text: 'Announcement', bgColor: 'rgba(236, 72, 153, 0.1)' };
        default:
            return { color: '#64748b', text: '资讯', bgColor: 'rgba(100, 116, 139, 0.1)' };
    }
};

// 快捷入口配置
export const QUICK_LINKS = [
    {
        title: '新建分析',
        icon: <BarChartOutlined />,
        path: '/analysis',
        color: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        shadowColor: 'rgba(102, 126, 234, 0.4)'
    },
    {
        title: 'SKU 管理',
        icon: <TeamOutlined />,
        path: '/sku-management',
        color: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        shadowColor: 'rgba(17, 153, 142, 0.4)'
    },
    {
        title: '品牌监控',
        icon: <TagsOutlined />,
        path: '/brand-management',
        color: 'linear-gradient(135deg, #ee0979 0%, #ff6a00 100%)',
        shadowColor: 'rgba(238, 9, 121, 0.4)'
    },
    {
        title: '数据导入',
        icon: <ThunderboltOutlined />,
        path: '/data-management',
        color: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        shadowColor: 'rgba(79, 172, 254, 0.4)'
    },
];

// 构建统计卡片配置
export const getStatCards = (data: DashboardStats | null) => [
    {
        title: 'SKU 总数',
        value: data?.stats.sku_count || 0,
        desc: '系统录入的产品总数',
        icon: <RocketOutlined />,
        gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        iconBg: 'rgba(102, 126, 234, 0.15)'
    },
    {
        title: '分析报告',
        value: data?.stats.report_count || 0,
        desc: '已生成的分析报告',
        icon: <BarChartOutlined />,
        gradient: 'linear-gradient(135deg, #f093fb 0%, #f5576c 100%)',
        iconBg: 'rgba(240, 147, 251, 0.15)'
    },
    {
        title: '活跃 SKU',
        value: data?.stats.active_sku_count || 0,
        desc: '最近有分析记录的产品',
        icon: <TrophyOutlined />,
        gradient: 'linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)',
        iconBg: 'rgba(79, 172, 254, 0.15)'
    },
    {
        title: '待处理任务',
        value: 0,
        desc: <Tag color="default" style={{ borderRadius: 10, fontSize: 11 }}>暂无任务</Tag>,
        icon: <SafetyCertificateOutlined />,
        gradient: 'linear-gradient(135deg, #11998e 0%, #38ef7d 100%)',
        iconBg: 'rgba(17, 153, 142, 0.15)'
    },
];

// HomeOutlined 图标组件
export const HomeOutlined = () => (
    <span role="img" aria-label="home" className="anticon anticon-home">
        <svg viewBox="64 64 896 896" focusable="false" data-icon="home" width="1em" height="1em" fill="currentColor" aria-hidden="true"><path d="M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 00-44.4 0L77.5 505a63.9 63.9 0 00-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0018.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z"></path></svg>
    </span>
);
